import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import * as styles from './PromoBadge.module.scss';

interface PromoBadgeProps {
  variant: 'season' | 'episode' | 'series' | 'documentary' | 'upcoming';
}

export const PromoBadge: FC<PromoBadgeProps> = ({ variant }) => {
  const { t } = useTranslation();

  const getPromoText = () => {
    switch (variant) {
      case 'season':
        return t('New Season');
      case 'episode':
        return t('New Episode');
      case 'series':
        return t('New Series');
      case 'documentary':
        return t('New Documentary');
      case 'upcoming':
        return `${t('Coming')}`;
    }
  };

  return <div className={styles.badge}>{getPromoText()}</div>;
};
